<template>
  <section class="evento-lux">
    <img src="@/assets/elemento2.png" class="petalo-flotante petalo-izq-1" alt="" />
    <img src="@/assets/elemento2.png" class="petalo-flotante petalo-der-1" alt="" />
    <img src="@/assets/elemento2.png" class="petalo-flotante petalo-izq-2" alt="" />

    <!-- Mariposas decorativas con aleteo fino, sutil y elegante estilo editorial -->
    <div class="mariposa-flotante mariposa-1">
      <img src="@/assets/mariposaa.png" alt="" />
    </div>
    <div class="mariposa-flotante mariposa-2">
      <img src="@/assets/mariposaa.png" alt="" />
    </div>

    <!-- BLOQUE 1: CEREMONIA -->
    <div ref="seccionBloque1" class="bloque-evento" aria-label="Ceremonia">
      <img class="icono-lazo" src="@/assets/bfcc6cffb98ca41900a2ac089000b051.png" alt="Icono Ceremonia" />
      
      <p class="hora-top">12:00 P.M. <span class="horario-zona">1:00 pm Horario Arizona <br> 12:00 pm Horario Nevada</span></p>
     <br><br> <h3 class="titulo-editorial">CEREMONIA</h3><br>
      <p class="lugar-luxury">La Santisima Trinidad Church</p>

      <!-- Imagen circular decorativa con GSAP -->
      <div class="contenedor-circular-lugar">
        <img src="@/assets/igless.jpeg" alt="Detalle Ceremonia" class="imagen-circular" />
      </div>

      <p class="direccion-editorial">
        3735 S Scenic Blvd<br /> Littlefield, Arizona.<br />
      </p>

      <a
        ref="btn1"
        class="btn-editorial-rosa"
        href="https://maps.app.goo.gl/JzyQ2T5t6ULbCpAh6"
        target="_blank"
        rel="noopener"
      >
        ¿Como llegar?
        <span class="sheen"></span>
      </a>
    </div>

    <div class="separador-bloques"></div>

    <!-- BLOQUE 2: RECEPCIÓN -->
    <div ref="seccionBloque2" class="bloque-evento" aria-label="Recepción">
      <img class="icono-lazo" src="@/assets/cek.png" alt="Icono Recepción" />
      
      <p class="hora-top">4:00 P.M. <span class="horario-zona">( 4:00 pm Horario Nevada )</span></p>
      <h3 class="titulo-editorial">RECEPCIÓN</h3><br>
      <p class="lugar-luxury">Desert EVENT Center</p>

      <!-- Imagen circular decorativa con GSAP -->
      <div class="contenedor-circular-lugar">
        <img src="@/assets/evenn.jpeg" alt="Detalle Recepción" class="imagen-circular" />
      </div>

      <p class="direccion-editorial">
        780 E Hafen Ln <br /> Mesquite, Nevada.<br />
      </p>

      <a
        ref="btn2"
        class="btn-editorial-rosa"
        href="https://maps.app.goo.gl/UrdyaKbhNaYt6KBd9"
        target="_blank"
        rel="noopener"
      >
        ¿Como llegar?
        <span class="sheen"></span>
      </a>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const seccionBloque1 = ref(null)
    const btn1 = ref(null)
    const seccionBloque2 = ref(null)
    const btn2 = ref(null)

    let ctx; 
    let animPetalos; 
    let animAleteo1, animAleteo2, animVuelo1, animVuelo2;

    const crearAnimacionBloque = (bloqueEl, btnEl) => {
      if (!bloqueEl || !btnEl) return

      const $ = gsap.utils.selector(bloqueEl)
      
      const lazo = $('.icono-lazo')
      const hora = $('.hora-top')
      const titulo = $('.titulo-editorial')
      const lugar = $('.lugar-luxury')
      const circulo = $('.contenedor-circular-lugar')
      const dir = $('.direccion-editorial')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: bloqueEl,
          start: 'top 82%', 
          toggleActions: 'play none none reverse' 
        },
        defaults: { ease: 'power3.out', duration: 0.6 }
      })

      tl.fromTo(bloqueEl, { opacity: 0, y: 35 }, { opacity: 1, y: 0, duration: 0.7 })
        .fromTo(lazo, { opacity: 0, scale: 0.6, y: -20 }, { opacity: 1, scale: 1, y: 0 }, '-=0.45')
        .fromTo(hora, { opacity: 0, y: 15 }, { opacity: 1, y: 0 }, '-=0.4')
        .fromTo(titulo, { opacity: 0, letterSpacing: '0.02em', y: 15 }, { opacity: 1, letterSpacing: 'initial', y: 0 }, '-=0.4')
        .fromTo(lugar, { opacity: 0, y: 15 }, { opacity: 1, y: 0 }, '-=0.4')
        .fromTo(circulo, { opacity: 0, scale: 0.5, y: 10 }, { opacity: 1, scale: 1, y: 0, duration: 0.5 }, '-=0.4')
        .fromTo(dir, { opacity: 0, y: 15 }, { opacity: 1, y: 0 }, '-=0.4')
        .fromTo(btnEl, { opacity: 0, y: 15, scale: 0.93 }, { opacity: 1, y: 0, scale: 1, duration: 0.4 }, '-=0.3')

      ScrollTrigger.create({
        trigger: bloqueEl,
        start: 'top 82%',
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 1.1, ease: 'power2.inOut', delay: 0.9 }
          )
        }
      })
    }

    onMounted(async () => {
      await nextTick()

      ctx = gsap.context(() => {
        if (seccionBloque1.value) crearAnimacionBloque(seccionBloque1.value, btn1.value)
        if (seccionBloque2.value) crearAnimacionBloque(seccionBloque2.value, btn2.value)
      })

      animPetalos = gsap.to('.petalo-flotante', {
        y: '+=10',
        rotation: '+=6',
        duration: 3.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        stagger: 0.35
      })

      animAleteo1 = gsap.to('.mariposa-1 img', {
        scaleX: 0.6,
        duration: 1.4,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      animAleteo2 = gsap.to('.mariposa-2 img', {
        scaleX: 0.55,
        duration: 1.7,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      animVuelo1 = gsap.to('.mariposa-1', {
        y: '-=15',
        x: '+=8',
        rotation: '+=5',
        duration: 3.2,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      animVuelo2 = gsap.to('.mariposa-2', {
        y: '+=12',
        x: '-=10',
        rotation: '-=6',
        duration: 3.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
      if (animPetalos) animPetalos.kill()
      if (animAleteo1) animAleteo1.kill()
      if (animAleteo2) animAleteo2.kill()
      if (animVuelo1) animVuelo1.kill()
      if (animVuelo2) animVuelo2.kill()
    })

    return { seccionBloque1, btn1, seccionBloque2, btn2 }
  }
}
</script>

<style scoped>
/* ==================== CONFIGURACIÓN ESTILO EDITORIAL COINCIDENTE ==================== */
.evento-lux {
  position: relative;
  width: 100%;
  padding: 4vh 5vw 6vh; 
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  margin-top: 0px !important; 
  align-items: center;
  margin-bottom: 60px;
  box-sizing: border-box;
  overflow: hidden;
}

/* ==================== BLOQUES CONTENEDORES CONTRAÍDOS ==================== */
.bloque-evento {
  width: min(100%, 420px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  margin-bottom: 0;
}

.separador-bloques {
  width: 60px;
  height: 1px;
  background-color: rgba(83, 101, 89, 0.25);
  margin: 50px 0;
}

.icono-lazo {
  width: auto;
  height: clamp(100px, 18vh, 150px) !important;
  display: block;
  margin: 0 auto 1.5vh;
  object-fit: contain;
  filter: drop-shadow(0 4px 10px rgba(225, 180, 185, 0.25));
}

/* ==================== IMAGEN CIRCULAR DECORATIVA ==================== */
.contenedor-circular-lugar {
  width: 188px;
  height: 188px;
  border-radius: 50%;
  overflow: hidden;
  margin: 1vh auto 1.5vh;
  border: 1.5px solid rgba(83, 101, 89, 0.35);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
  background-color: #faf9f6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.imagen-circular {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ==================== TIPOGRAFÍAS DE ALTA GAMA ==================== */
.hora-top {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.2rem, 3.8vw, 1.45rem);
  font-weight: 800;
  color: #536559;
  margin: 0 0 0.5vh 0;
  letter-spacing: 0.03em;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.horario-zona {
  font-size: clamp(0.95rem, 2.5vw, 0.98rem);
  color: #383d39;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.titulo-editorial {
  font-family: 'Playfair Display', serif;
  font-weight: 400;
  font-size: clamp(1.4rem, 6.5vw, 1.75rem);
  color: #536559;
  margin: 0 0 1vh 0;
  letter-spacing: 0.12em;
  line-height: 1.15;
}

.lugar-luxury {
  font-family: 'padres', serif;
  font-size: clamp(1.4rem, 5vw, 1.4rem);
  color: #536559;
  font-weight: 900;
  margin: 0.5vh 0 0.5vh 0;
  line-height: 1.2;
}

.direccion-editorial {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  color: #555555;
  font-size: clamp(0.9rem, 3.2vw, 1rem);
  line-height: 1.5;
  margin: 0 auto 2vh;
  max-width: 85%;
  letter-spacing: 0.02em;
}

/* ==================== BOTÓN DE DISEÑO FLUSH ==================== */
.btn-editorial-rosa {
  display: inline-flex !important;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 1.2vh 6vw;
  border-radius: 14px;
  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  background-color: #bf953f;
  color: #0a0a0a !important;
  -webkit-text-fill-color: #0a0a0a !important;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 900;
  font-size: clamp(0.99rem, 3.5vw, 1.2rem);
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.5);
  border: 1px solid #8a6d3b;
  cursor: pointer;
  z-index: 5;
  overflow: hidden;
}

.btn-editorial-rosa:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(222, 176, 182, 0.5);
}

.btn-editorial-rosa:active {
  transform: translateY(0);
}

/* ==================== PÉTALOS ACENTUADOS A LOS COSTADOS ==================== */
.petalo-flotante {
  position: absolute;
  width: clamp(50px, 18vw, 85px);
  height: auto;
  object-fit: contain;
  pointer-events: none;
  opacity: 0.85;
  z-index: 1;
}

.petalo-izq-1 {
  top: 5%;
  left: -2vw;
  transform: rotate(-15deg);
}

.petalo-der-1 {
  top: 45%;
  right: -3vw;
  transform: rotate(20deg) scaleX(-1);
}

.petalo-izq-2 {
  top: 85%;
  left: -2vw;
  transform: rotate(-10deg);
}

/* ==================== MARIPOSAS CON ALETEO FINO Y SUTIL ==================== */
.mariposa-flotante {
  position: absolute;
  width: clamp(135px, 22vw, 155px);
  height: auto;
  pointer-events: none;
  opacity: 0.92;
  z-index: 3;
  will-change: transform;
}

.mariposa-flotante img {
  width: 100%;
  height: auto;
  display: block;
  transform-origin: center center;
  will-change: transform;
}

.mariposa-1 {
  top: -2%;
  right: -6%;
  transform: rotate(15deg);
}

.mariposa-2 {
  top: 90%;
  left: -6%;
  transform: rotate(-20deg) scaleX(-1);
}

@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}
</style>